import { supabase } from '@/integrations/supabase/client';
import { useCartStore } from '@/stores/cartStore';
import { trackBeginCheckout } from '@/lib/analytics';
import { toast } from 'sonner';
import { getEditorialSource, measurementAllowed } from '@/lib/editorialAttribution';
import { flushCheckoutNotice } from '@/lib/checkoutReassurance';
import { checkoutEmailSource } from '@/lib/emailAttribution';

let pending: Promise<void> | undefined;
export function startPartnerCheckout(source: 'cart' | 'drawer' | 'buy_now'): Promise<void> {
  if (pending) return pending;
  pending = (async () => {
    const cart = useCartStore.getState();
    const url = cart.getCheckoutUrl();
    if (!url || !cart.cartId || !cart.items.length) return;
    await flushCheckoutNotice();
    try {
      const { error } = await supabase.functions.invoke('checkout-reconciliation', {
        body: { action: 'start', cartId: cart.cartId, source, editorial: getEditorialSource(), email: await checkoutEmailSource(), measureNotice: measurementAllowed() },
      });
      if (error) toast.warning('Order linking is unavailable. You can still complete payment with our checkout partner.');
    } catch {
      toast.warning('Order linking is unavailable. Partner checkout is still available.');
    }
    trackBeginCheckout(cart.getTotalPrice(), cart.items[0]?.price.currencyCode || 'USD');
    window.location.assign(url);
  })().finally(() => { pending = undefined; });
  return pending;
}